import { atom } from 'jotai';
import { fetchPaymentAccounts } from '../api';
import { useMemo } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';

export const usePaymentAccountOptions = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchPaymentAccounts'],
    queryFn: () => {
      return fetchPaymentAccounts().then(
        ({ paymentAccounts }) => paymentAccounts
      );
    },
  });

  return useMemo(() => {
    return data.map(({ accountCode }) => ({
      label: accountCode,
      value: accountCode,
    }));
  }, [data]);
};
